export default {
	serviceNowEnv: process.env.REACT_APP_SERVICENOW_ENV
};